import script from "./UploadPage.vue?vue&type=script&setup=true&lang=js"
export * from "./UploadPage.vue?vue&type=script&setup=true&lang=js"

import "./UploadPage.vue?vue&type=style&index=0&id=3cca7254&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3cca7254"]])

export default __exports__